import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

/**
 * The purpose of this intercept is to set the bypass authentication in a header for staging environment.
 */

@Injectable({
  providedIn: 'root',
})
export class StagingInterceptor implements HttpInterceptor {
  /**
   * This function is to bypass the Authentication for the staging.
   *
   * @param request - Represents the request on its way to the server. We are manipulated this parameter inside the intercept method before sending the newly modified request onto the server to bypass the Authentication for staging.
   * @param next - Represents next step in the interceptor chain.
   * @returns - Observable that wraps up an HttpEvent object.
   */
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // check if current environment requires the bypass token to be set
    // currently this is only needed on staging and uat
    if (environment.apiHeaders['X-Bypass-Authentication'] && environment.environmentName !== 'production') {
      // set bypass authentication in a header
      request = request.clone({
        headers: request.headers.set('X-Bypass-Authentication', environment.apiHeaders['X-Bypass-Authentication']),
      });
    }

    return next.handle(request);
  }
}
